interface SlideProps {
    Slide: {
        id: string;
    }
}

const Slide: React.FC<SlideProps> = ({ Slide }) => {
    return (
        <img src={`/assets/clients/client-${Slide.id}.png`} alt="client" height={80} />
    )
}

export { Slide }